import type { FunctionComponent } from 'react'
import React from 'react'
import type { FieldProps } from 'formik'
import { useFormikContext } from 'formik'
import { InlineDisplayContent } from '@ztechapps/webui.input'
import type { FieldInputProps, FieldMetaProps, FormikProps } from 'formik/dist/types'

export type FieldEditorComponentProps<FormValues = any> = {
  disabled?: boolean
  isDisabled?: boolean
  onChange?: (e: any) => void
  onBlur?: (e: any) => void
  form?: FormikProps<FormValues>
  meta?: FieldMetaProps<any>
} & FieldInputProps<any> &
  Record<any, any>

export type FieldEditorProps = {
  name: string
  label?: string
  help?: string
  showHelpAsInline?: boolean
  fieldProps: FieldProps
  component: FunctionComponent<FieldEditorComponentProps>
  componentProps?: FieldEditorComponentProps
  onChange?: (e: any) => void
  onBlur?: (e: any) => void
  horizontalLayout?: boolean
  horizontalFormLabelWidth?: number
}

export const FieldEditor = (props: FieldEditorProps) => {
  const { component, fieldProps, componentProps = {} } = props
  const Component = component
  const { isSubmitting } = useFormikContext()

  return (
    <InlineDisplayContent
      label={props.label}
      help={props.help}
      showHelpAsInline={props.showHelpAsInline}
      formikField={props.fieldProps}
      horizontalLayout={props.horizontalLayout}
      horizontalFormLabelWidth={props.horizontalFormLabelWidth}
      value={
        <Component
          {...{
            disabled: isSubmitting,
            isDisabled: isSubmitting,
            ...fieldProps.field,
            ...componentProps,
            form: fieldProps.form,
            meta: fieldProps.meta,
            onChange: props.onChange,
            onBlur: props.onBlur,
          }}
        />
      }
    />
  )
}
